export default __webpack_public_path__ + "static/media/logo-adrena-white.ffc9ca08.png";